export const singularStatusMapLabel = {
  requested: 'Aguardando aprovação',
  rejected: 'Rejeitado',
  approved: 'Aprovado',
  canceled: 'Cancelado',
}
